/* eslint-disable eqeqeq */
/* eslint-disable no-console */
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateHome } from "../../../Redux/Slices/home.slice";
import { client } from "../../../Utils/axiosClient";
import CloseIcon from "../../../Common/Svgs/CloseIcon";

const ItemBody17 = ({ notification }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAcceptRequest = () => {
    dispatch(updateHome({ key: "notificationPopupVisible", value: false }));
    navigate("/rentals");
  };

  const onReject = async () => {
    dispatch(updateHome({ key: "notificationPopupVisible", value: false }));

    try {
      const payload = {
        requestId: parseInt(notification?.metaData?.requestId, 10),
      };

      dispatch(updateHome({ key: "loading", value: true }));

      await client.post(
        `${process.env.REACT_APP_API_URL}/battery/reject-request`,
        payload,
      );
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(updateHome({ key: "loading", value: false }));
    }
  };

  return (
    <div>
      <p className="font-poppins text-xs font-light text-black">
        <span className="font-medium text-primary capitalize">
          {notification?.metaData?.receiverHubName}{" "}
        </span>
        is requesting batteries for a rental trip ID{" "}
        <span className="font-medium">{notification?.metaData?.rentalId}.</span>{" "}
        Do you want to accept?
      </p>

      {/* if action is performed, do not show the button */}
      {notification?.metaData?.action == 1 ? null : (
        <div className="mt-1 w-full flex items-center gap-x-2">
          <button
            type="button"
            className="flex-1 bg-primary hover:bg-primary-50 py-2 px-4 text-center rounded-md"
            onClick={handleAcceptRequest}
          >
            <p className="font-poppins text-xs font-medium text-background-white">
              Accept Request
            </p>
          </button>

          <button
            type="button"
            className="flex flex-1 items-center gap-x-2 bg-alert-10 hover:bg-light-alert-red py-2 px-4 rounded-md"
            onClick={onReject}
          >
            <CloseIcon className="w-4 h-4 stroke-alert-red" />

            <p className="font-poppins text-xs font-medium text-alert-red">
              Reject
            </p>
          </button>
        </div>
      )}
    </div>
  );
};

export default ItemBody17;
